import React from 'react';
import PropTypes from 'prop-types'
import classNames from 'classnames';
import { StyleSheet, css } from '../../utility/paypalAphrodite';
import colors from '../../styles/colors';
import fonts from '../../styles/fonts';
import { formatAmountFromServerDNW } from './amountUtils';
import { getCurrencyParts } from '../../utility/formator'

const buttonStyles = {
	amountBtn: {
		width: '86px',
		height: '48px',
		padding: 0,
		borderRadius: '5px',
		border: '1px solid #0070BA',
		fontSize: '16px',
		fontFamily: fonts.ppSansBigMedium,
		textDecoration: 'none',
		// Reduce width in xs screens to
		// fit 3 buttons in a row
		'@media (max-width: 340px)': {
			width: '78px'
		}
	},
	defaultColor: {
		backgroundColor: 'white',
		color: colors.primaryLightBlue,
		':hover': {
			color: colors.primaryBlue,
			borderColor: colors.primaryBlue,
			boxShadow: `0 0 0 1px ${colors.primaryBlue} inset`
		},
		':active': {
			color: colors.primaryBlue,
			borderColor: colors.primaryBlue,
			boxShadow: `0 0 0 1px ${colors.primaryBlue} inset`
		},
		':focus': {
			color: colors.primaryBlue,
			borderColor: colors.primaryBlue,
			boxShadow: `0 0 0 1px ${colors.primaryBlue} inset`
		}
	},
	highlightedColor: {
		backgroundColor: colors.primaryLightBlue,
		color: 'white'
	},
}

const STYLES = StyleSheet.create({
	defaultBtn: {
		...buttonStyles.amountBtn,
		...buttonStyles.defaultColor
	},
	highlightedBtn: {
		...buttonStyles.amountBtn,
		...buttonStyles.highlightedColor
	},
	currencyStyle: {
		fontFamily: fonts.ppSansSmallMedium,
		whiteSpace: 'nowrap' // Do not wrap amount to next line
	},
	currencyCodeStyle: {
		fontFamily: fonts.ppSansSmallRegular,
		fontSize: 11,
		marginTop: -4
	}
});

class PresetAmountButton extends React.Component {
	constructor(props) {
		super(props);
		const [firstParts = {}] = getCurrencyParts();
		const rightSymbol = firstParts.$ !== 'symbol';
		this.state = {
			rightSymbol
		}
	}
	
	handleClick = (event, value) => {
		this.props.handleAmountBtnClick(event, value)
	}

	getAmountDisplayValue = () => {
		let amountDisplayValue;
		if (this.state.rightSymbol) {
			amountDisplayValue = this.props.symbol ?
				`${formatAmountFromServerDNW(this.props.value, this.props.charityAmountCode)} ${this.props.symbol}` :
				`${formatAmountFromServerDNW(this.props.value, this.props.charityAmountCode)}`
		} else {
			amountDisplayValue = this.props.symbol ?
				`${this.props.symbol}${formatAmountFromServerDNW(this.props.value, this.props.charityAmountCode)}` :
				`${formatAmountFromServerDNW(this.props.value, this.props.charityAmountCode)}`

		}
		return amountDisplayValue;
	}

	getAmountFontSize = (amountDisplayValue) => {
		if (amountDisplayValue.length < 11) {
			return '15px';
		}
		return '12px';
	}

	render() {
		const { selected } = this.props;
		const btnClasses = classNames(
			'vx_btn', {
				[css(STYLES.highlightedBtn)]: selected,
				[css(STYLES.defaultBtn)]: !selected,
			})
		const formattedAmount = formatAmountFromServerDNW(this.props.value, this.props.charityAmountCode);
		const amountDisplayValue = this.getAmountDisplayValue();
		const amountFontSize = this.getAmountFontSize(amountDisplayValue);

		return (
			<button type="button"
				className={btnClasses}
				onClick={(event) => this.handleClick(event, formattedAmount)}
			>
				<div
					className={css(STYLES.currencyStyle)}
					data-testid="preset-button-value"
					style={{
						fontSize: amountFontSize
					}}
				>{amountDisplayValue}</div>
				<div className={css(STYLES.currencyCodeStyle)}>{this.props.charityAmountCode}</div>
			</button>
		);
	}
}

PresetAmountButton.propTypes = {
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	selected: PropTypes.bool,
	symbol: PropTypes.string,
	handleAmountBtnClick: PropTypes.func.isRequired,
	charityAmountCode: PropTypes.string
};

export default PresetAmountButton;



// WEBPACK FOOTER //
// ./components/amount/PresetAmountButton.js